
import { ThreeDots } from 'react-loader-spinner';

const Loader = () => {
    return (
        <div className="contenedor_loader">
            <div className="text-center">
                <img className="d-inline-block my-4" alt="logo" width="200" src={process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/logo/imagotipo-blanco.png'}/>
                <div className="contenedor_animacion">
                    <ThreeDots 
                        height="50" 
                        width="50" 
                        radius="9"
                        color="#176a74" 
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{ display: 'block' }}
                        visible={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default Loader;
